(() => {
  // Number counters
  function animateCounterOnScroll(
    element,
    targetValue,
    duration = 2000,
    threshold = 1
  ) {
    // Check the element exists
    if (!element) {
      return;
    }
    // Flag to ensure animation only runs once
    let hasAnimated = false;

    // Function to format number with commas
    function formatWithCommas(num) {
      return Math.round(num).toLocaleString();
    }

    // The actual counter animation function
    function animateCounter() {
      if (hasAnimated) return;
      hasAnimated = true;
      // Starting value
      let startValue = 0;
      // Set initial display to 0
      element.textContent = formatWithCommas(startValue);
      // Start time
      const startTime = performance.now();
      // Animation function
      function updateCounter(timestamp) {
        // Calculate elapsed time
        const elapsed = timestamp - startTime;
        // Calculate progress (0 to 1)
        const progress = Math.min(elapsed / duration, 1);
        // Apply easing function for smoother animation
        // This uses an ease-out cubic function
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        // Calculate the current value based on progress
        const currentValue =
          startValue + (targetValue - startValue) * easedProgress;
        // Format with commas and update the element's content
        element.textContent = formatWithCommas(currentValue);
        // Continue the animation if not complete
        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        }
      }
      // Start the animation
      requestAnimationFrame(updateCounter);
    }
    // Set up Intersection Observer to detect when element enters viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            // Immediately clear content and show starting value
            animateCounter();
            // Stop observing after animation starts
            observer.unobserve(element);
          }
        });
      },
      {
        threshold: threshold,
      }
    );
    // Start observing the element
    observer.observe(element);
    // Return the observer in case we need to manually stop it
    return observer;
  }

  // Initialize observers when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const counters = document.querySelectorAll('.uom-2035-counter');
    if (!counters) return;

    for (let i = 0; i < counters.length; i++) {
      const counter = counters[i];

      // Set element height to prevent juttering effect
      const counterHeight = counter.getBoundingClientRect().height;
      counter.style.height = counterHeight + 'px';

      // Remove text content so the animation appears to start from nothing
      counter.textContent = '';

      animateCounterOnScroll(
        counter,
        counter.getAttribute('data-final-number')
      );
    }
  });
})();
